Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "members1982538223",
  {"root":"members1982538223--root","avatars":"members1982538223--avatars","avatarsSingleLayout":"members1982538223--avatarsSingleLayout","avatarsCalendarLayout":"members1982538223--avatarsCalendarLayout","avatarsListLayout":"members1982538223--avatarsListLayout","avatarsDefault":"members1982538223--avatarsDefault","avatarsOnImage":"members1982538223--avatarsOnImage","avatar":"members1982538223--avatar"},
  "",
  9,
  "members1982538223"
);

